/**
 * ACCORDION TOKENS
 */
import { SEMANTIC, type SemanticTokens } from '../semantic.js';

export function createAccordionTokens(s: SemanticTokens) {
  return {
    base: {
      padding: s.layout.gap.md, // --accordion-base-padding: var(--spacing-16)
      radius: s.radius.md, // --accordion-base-radius: var(--radius-8)
      borderWidth: '1px', // --accordion-base-border-width
      transitionDuration: s.transition.normal, // --accordion-base-transition-duration
      panelGap: s.layout.gap.md, // --accordion-base-panel-gap: var(--spacing-16)
    },
    header: {
      fontSize: s.typography.fontSize.base, // --accordion-header-font-size
      lineHeight: s.typography.lineHeight.xl,
      fontWeight: s.typography.fontWeight.semibold, // --accordion-header-font-weight
      gap: s.layout.gap.md, // --accordion-header-gap: var(--spacing-16)
    },
    content: {
      fontSize: s.typography.fontSize.base, // --accordion-content-font-size
      fontWeight: s.typography.fontWeight.normal, // --accordion-content-font-weight
      lineHeight: s.typography.lineHeight.xl, // --accordion-content-line-height
    },
    icon: {
      size: s.iconSizes.lg, // --accordion-icon-size
    },
    bg: s.surface.ground, // --accordion-bg: var(--surface-ground)
    fg: s.text.secondary, // --accordion-fg: var(--text-secondary)
    border: s.border.default, // --accordion-border: var(--border-default)
    contentBg: s.surface.ground, // --accordion-content-bg: var(--surface-ground)
    contentFg: s.text.secondary, // --accordion-content-fg: var(--text-secondary)
  };
}
export const accordionTokens = createAccordionTokens(SEMANTIC);
